if (window.tabModule === undefined) {
  window.tabModule = (() => {
    const createLink = (text, href) => {
      const link = document.createElement("a");
      link.classList.add("tab__list-link");
      link.href = href;
      link.innerText = text;
      return link;
    };

    const createImage = () => {
      const image = document.createElement("img");
      image.classList.add("tab__list-icon");
      image.src =
        "https://cdn.shopify.com/s/files/1/0332/2013/2997/files/hakchen.png?v=1683040621";
      image.width = "18";
      image.style.display = "inline";
      return image;
    };

    const formatString = (value) => {
      // create list item
      const item = document.createElement("li");
      item.classList.add("tab__list-item");
      const includesIcon = value.includes("✔️") || value.includes("✅");
      const newValue = includesIcon
        ? value.replace("✅", "").replace("✔️", "")
        : value;
      if (includesIcon) {
        item.appendChild(createImage());
      }

      // link start
      const linkStart = newValue.indexOf("[");
      // link end
      const linkEnd = newValue.indexOf("]");

      if (linkStart !== -1 && linkEnd !== -1) {
        const markup = newValue.substring(linkStart + 1, linkEnd);
        const tag = newValue.substring(linkStart, linkEnd + 1);

        const [text, link] = markup.split("=");

        const anchor = createLink(text, link).outerHTML;

        const anchorString = newValue.replace(tag, anchor);

        item.innerHTML += anchorString;

        return item;
      }
      item.innerHTML += newValue;
      return item;
    };

    const init = () => {
      const tabs = document.querySelectorAll(".js-find-description");
      tabs.forEach((tab) => {
        const container = document.createElement("ul");
        container.classList.add("tab__list");
        const text = tab.innerHTML;
        if (text.includes("<li")) {
          return;
        }
        const values = text.split("\n");
        const filteredValues = values.filter((v) => v.trim() !== "");
        const newValues = filteredValues.map((value) => formatString(value));
        newValues.forEach((newValue) => {
          container.appendChild(newValue);
        });
        tab.innerHTML = "";
        tab.appendChild(container);
      });
    };

    init();
  })();
}
